import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable, BehaviorSubject } from 'rxjs';
import { IJoinUs, Icommon, IDefaultResult, IContactUs } from './IJoinUs';
import * as backEnd from '../Shared/globalVar';

@Injectable({
  providedIn: 'root'
})
export class JoinUsService {

  constructor(
    private http: HttpClient,
    private router: Router
  ) {}


  public AddJoinUs(info: IJoinUs): Observable<IDefaultResult> {
   const url = backEnd.apiUrlV1 + 'joinus/add';
    return this.http.post<IDefaultResult>(url, info);
  }


  public AddContactUs(info: IContactUs): Observable<IDefaultResult> {
    const url = backEnd.apiUrlV1 + 'contactus';
     return this.http.post<IDefaultResult>(url, info);
   }

  getServiveCategories(): Observable<IDefaultResult> {
    let key = 'FFN07C5F5514F4DDA3CA9F96DE48119EC7EA';
    const url = backEnd.apiUrlV1 + 'service-categories/en/' + key;
    return this.http.get<IDefaultResult>(url); // Icommon
  }

  getPartners(): Observable<IDefaultResult> {
    const url = backEnd.apiUrlV1 + 'partner/en/';
    return this.http.get<IDefaultResult>(url); //Islider[]
  }


getNumberTransactions(): Observable<IDefaultResult> {
  // let key = 'LKBBKEAAA32111Ydd@ahzzz&h=h$b310@2022';
  const url = 'https://testapi.klickit.co/api/v1/transactions/count?appKey=LKBBKEAAA32111Ydd@ahzzz&h=h$b310@2022';
  return this.http.post<IDefaultResult>(url,''); // Icommon
}

}
